import { useNavigate } from "react-router-dom";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { useTranslation } from "context/LanguageContext";

const BackButton = ({ title }) => {
  const navigate = useNavigate();
  const { language } = useTranslation();
  const isRTL = language === "ar";

  return (
    <div className={`flex items-center gap-3 sm:gap-4 ${isRTL ? "flex-row-reverse" : ""}`}>
      <button
        onClick={() => navigate(-1)}
        className="p-2 hover:bg-gray-100 rounded-full transition-colors flex-shrink-0"
        aria-label="Go back"
      >
        {isRTL ? (
          <IoIosArrowForward className="w-5 h-5"/>
        ) : (
          <IoIosArrowBack className="w-5 h-5"/>
        )}
      </button>
      <h1 className={`text-lg sm:text-xl lg:text-2xl font-semibold text-gray-800 truncate ${
        isRTL ? "text-right" : "text-left"
      }`}>
        {title}
      </h1>
    </div>
  );
};

export default BackButton;
